import { useNavigate, useLocation } from 'react-router-dom';
import { useContext, useEffect, useRef, useState } from 'react';

import { DataContext } from 'providers/data';

import Box from '@mui/material/Box';
import Modals from 'components/views/Modals';
import Typography from '@mui/material/Typography';
import { ButtonRectangle, ButtonOutlined } from 'components/views/form/Button';

import { ReactComponent as IcIturanShoppingCart } from 'assets/icons/ic-ituran-shopping-cart.svg';

import { AdditionalServices, Container, ContentButton, ContentCart, ContentPlan, ContentTotal, RiskWhite, TypographyText } from './styles';

const ShoppingCart = ({ isWebView = false }: { isWebView?: boolean }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [isLoading, setIsLoading] = useState(false);

    const { dataListQuoteAdd, dataProductCartAddServices, dataChooseQuoteItemsAddServices, handlePostChooseQuoteItemsAddServices } = useContext(DataContext);

    const refOpen = useRef<HTMLDivElement>(null);
    const refScroll = useRef<HTMLDivElement>(null);
    const refAddService = useRef<HTMLLIElement>(null);

    const [isShow, setIsShow] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenAnimation, setIsOpenAnimation] = useState(false);

    const [isOpenModal, setIsOpenModal] = useState(false);

    const handlePostChooseQuoteItemsAddServicesState = () => {
        setIsLoading(true);
        if (dataListQuoteAdd) {
            handlePostChooseQuoteItemsAddServices({
                CD_COTACAO: dataListQuoteAdd.CD_COTACAO,
                CD_CANAL_VENDA: dataListQuoteAdd.CD_CANAL_VENDA,
                CD_PESSOA_PARCEIRO: dataListQuoteAdd.CD_PESSOA_PARCEIRO,
                CD_PESSOA_VENDEDOR: dataListQuoteAdd.CD_PESSOA_VENDEDOR,
                CD_PESSOA_PARCEIRO_ESTABELECIMENTO: dataListQuoteAdd.CD_PESSOA_PARCEIRO_ESTABELECIMENTO
            },
                isWebView
            );
        }
    }

    useEffect(() => {
        const handleScroll = () => {
            if (refScroll.current && window.innerWidth > 992 && window.scrollY < (document.body.clientHeight - 1100)) {
                refScroll.current.style.top = `${window.scrollY + (window.innerHeight > 850 ? 58 : 83)}px`;
            }
        }

        const handleClose = (e: any) => {
            if (refOpen.current?.contains(e.target)) {
                setIsOpen(false);
            }

            if (refScroll.current?.contains(e.target)) {
                setIsOpen(true);
                if (isOpen && !refAddService.current?.contains(e.target)) {
                    setIsOpen(false);
                }
            }
        }

        window.addEventListener('scroll', handleScroll);
        document.body.addEventListener('click', handleClose);

        return () => {
            window.removeEventListener('click', handleScroll);
            document.body.removeEventListener('click', handleClose);
        }
    });

    useEffect(() => {
        setTimeout(() => {
            setIsOpenAnimation(isOpen);
        }, !isOpen ? 400 : 0);
    }, [isOpen]);

    useEffect(() => {
        setTimeout(() => {
            setIsShow(true);
            setIsOpenAnimation(false);
        }, 400);

        setIsShow(false);
    }, []);

    useEffect(() => {
        if (typeof dataChooseQuoteItemsAddServices !== "undefined") {
            setIsLoading(false);
        }
    }, [dataChooseQuoteItemsAddServices]);

    return (
        <ContentCart
            ref={refOpen}
            className={isOpen ? 'open' : 'close'}
            primaryshow={isShow ? 'active' : 'disabled'}
            isWebView={isWebView ? 'active' : 'disabled'}
        >
            <Container ref={refScroll} className={isOpenAnimation ? 'open' : 'close'}>
                <RiskWhite />
                <Typography variant='h5' color='white' fontWeight={700} marginBottom='1.5rem' textTransform='uppercase'>
                    Resumo do seu pedido
                </Typography>

                <Box onClick={() => setIsOpen(isOpen)} sx={{ position: 'absolute', top: '1.6rem', right: '1.4rem', display: { xs: 'block', md: 'none' } }}>
                    {dataProductCartAddServices?.productAdd?.length > 0 &&
                        <Box sx={{ position: 'absolute', top: '-8px', right: '-8px', width: '.93rem', height: '.93rem', borderRadius: '100px', backgroundColor: 'secondary.main' }} />
                    }
                    <IcIturanShoppingCart />
                </Box>

                <ContentPlan>
                    <nav style={{ marginBottom: '1rem' }}>
                        <Typography variant='h6' padding='6px 6px 0' fontWeight={700} width='fit-content' textTransform='capitalize'>
                            Serviços adicionais
                        </Typography>
                    </nav>

                    <AdditionalServices>
                        <Box sx={{
                            width: '100%',
                            position: 'relative',
                            maxHeight: { xs: '9rem', md: '6.5rem' },
                            overflowY: 'auto',
                            display: 'grid',
                            paddingTop: '.5rem',
                            gap: '.5rem',
                            marginRight: dataProductCartAddServices?.productAdd?.length > 3 ? { xs: '-10px', md: '-22.3px' } : '0',
                            paddingRight: dataProductCartAddServices?.productAdd?.length > 3 ? '.52rem' : '0',
                            '::-webkit-scrollbar': {
                                width: '.93rem',
                            },
                            '::-webkit-scrollbar-thumb': {
                                background: '#8D9BB5',
                                borderRadius: '.625rem'
                            }
                        }}>
                            {dataProductCartAddServices.productAdd.map(({ nM_PRODUTO, vL_TOTAL }, index) => (
                                <li ref={refAddService} key={index}>
                                    <TypographyText variant='subtitle2'>
                                        {nM_PRODUTO}
                                    </TypographyText>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <TypographyText variant='subtitle2'>
                                            {vL_TOTAL}
                                        </TypographyText>
                                    </Box>
                                </li>
                            ))}
                        </Box>
                        {dataProductCartAddServices.productAdd.length === 0 &&
                            <Typography sx={{ fontSize: '1rem', fontWeight: '600', color: 'white' }}>
                                Adicione um de nossos serviços!
                            </Typography>
                        }
                    </AdditionalServices>
                </ContentPlan>

                <ContentTotal>
                    <nav>
                        <Typography
                            padding='6px 6px 0'
                            fontWeight={700}
                            width='fit-content'
                            sx={{
                                fontSize: '1.25rem',
                                borderRadius: '5px 5px 0px 0px',
                                backgroundColor: '#97C93D'
                            }}>
                            TOTAL
                        </Typography>
                    </nav>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end' }}>
                        <TypographyText variant='subtitle2' lineHeight='23px' textTransform="uppercase">
                            mensalidades
                        </TypographyText>

                        <TypographyText variant='h5'>
                            <span style={{ fontSize: '.75rem', fontWeight: '400' }}>R$&nbsp;&nbsp;</span>
                            {dataProductCartAddServices.vL_TOTAL_Cart && dataProductCartAddServices.vL_TOTAL_Cart !== "0,00" ?
                                parseFloat(`${dataProductCartAddServices.vL_TOTAL_Cart}`.replace(',', '.')).toLocaleString('pt-br', { minimumFractionDigits: 2 }) :
                                '0,00'
                            }
                        </TypographyText>
                    </Box>

                    {pathname.split('/')[2] === 'servicos' &&
                        <ContentButton>
                            <ButtonRectangle
                                name='CONTINUAR'
                                disabled={dataProductCartAddServices?.productAdd?.length === 0}
                                loadingBtn={isLoading}
                                onClick={() => handlePostChooseQuoteItemsAddServicesState()} />
                            <Box sx={{ 'button': { marginTop: '.5rem', borderColor: 'white', color: 'white', '&:hover': { borderColor: 'white', opacity: '.8' } } }}>
                                <ButtonOutlined
                                    name='CANCELAR'
                                    onClick={() => setIsOpenModal(true)} />
                            </Box>
                        </ContentButton>
                    }
                </ContentTotal>
            </Container>

            <Modals open={isOpenModal}>
                <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '25.6rem' } }}>
                    <Box sx={{ padding: { xs: '1.78rem .9rem .59rem', md: '1.78rem 1.71rem 1.59rem' } }}>
                        <Typography fontSize='1.25rem' paddingBottom='1rem' fontWeight='700'>
                            Poxa, que pena que desistiu!
                        </Typography>
                        <Typography fontSize='1rem' lineHeight='1.27'>
                            Não se preocupe, o seu pedido <b>está guardado</b>, volte quando quiser e continue de onde parou.
                        </Typography>
                    </Box>
                    <Box sx={{ borderRadius: '0 0 8px 8px', backgroundColor: 'primary.main', padding: { xs: '2.17rem 2.6rem 2.5rem', md: '2.17rem 4.21rem 2.57rem' }, 'button': { width: '100%' } }}>
                        <ButtonRectangle
                            name='FECHAR'
                            onClick={() => navigate('/servicos-adicionais')} />
                    </Box>
                </Box>
            </Modals>
        </ContentCart >
    )
}

export default ShoppingCart;